import { ROUTE_NAMES, SUPPORT_ENTRY_PATH } from '@/constants/route-constants';

const Login = () => import('@/views/Login.vue');
const UIKit = () => import('@/views/UIKit.vue');
const InternationalDashboard = () => import('@/views/dashboard/InternationalDashboard');
const UsersControl = () => import('@/views/users/UsersControl');
const CustomersControl = () => import('@/views/customers/CustomersControl');
const FormCustomer = () => import('@/views/customers/FormCustomer');
const CustomersAuthorizationControl = () =>
  import('@/views/customers/CustomersAuthorizationControl');
const FormAuthorizationCustomer = () => import('@/views/customers/FormAuthorizationCustomer');
const FormCorrespondent = () => import('@/views/correspondents/FormCorrespondent');
const CorrespondentsControl = () => import('@/views/correspondents/CorrespondentsControl');
const PreSaleReport = () => import('@/views/reports/PreSaleReport');
const NotificationHistory = () => import('@/views/notifications/NotificationHistory.vue');
const ExchangeOperationReport = () => import('@/views/reports/ExchangeOperationReport');
const RemittanceOperationReport = () => import('@/views/reports/RemittanceOperationReport');
const StablecoinRemittanceOperationReport = () =>
  import('@/views/reports/StablecoinRemittanceOperationReport');
const RemittanceOperationManagementReport = () =>
  import('@/views/reports/RemittanceOperationManagementReport');
const ExchangeClosing = () => import('@/views/exchange-closing/ExchangeClosing.vue');
const DuimpDueOperationReport = () => import('@/views/reports/DuimpDueOperationReport.vue');
const StablecoinRemittanceOperationManagementReport = () =>
  import('@/views/reports/StablecoinRemittanceOperationManagementReport');
const FormOperation = () => import('@/views/operations/FormOperation');
const CommissionsControl = () => import('@/views/operations/CommissionsControl');
const ExchangeBankControl = () => import('@/views/registrations/exchangeBanks/ExchangeBankControl');
const ExchangeFormBank = () => import('@/views/registrations/exchangeBanks/ExchangeFormBank');
const OperationNaturesControl = () =>
  import('@/views/registrations/operations/OperationNaturesControl');
const CurrenciesControl = () => import('@/views/registrations/operations/CurrenciesControl');
const CurrencyHolidaysControl = () => import('@/views/registrations/currencyHolidays/CurrencyHolidaysView');
const PaymentMethodsControl = () =>
  import('@/views/registrations/operations/PaymentMethodsControl');
const RateApiRouteControl = () => import('@/views/registrations/integrations/RateApiRouteControl');
const TemplatesControl = () => import('@/views/registrations/templates/TemplatesControl');
const TemplateTypeSelector = () => import('@/views/registrations/templates/TemplateTypeSelector');
const FormTemplate = () => import('@/views/registrations/templates/FormTemplate');
const Configuration = () => import('@/views/configurations/generic/configuration/Configuration');
const FormCustomerFinally = () => import('@/views/customers/FormCustomerFinally');
const CustomerDocumentsExternalAccess = () =>
  import('@/views/customers/CustomerDocumentsExternalAccess');
const OperationDocumentsExternalAccess = () =>
  import('@/views/operations/OperationDocumentsExternalAccess');
const DuimpExternalAccess = () =>
  import('@/views/operations/DuimpExternalAccess.vue');
const BankDocumentsExternalAccess = () =>
  import('@/views/operations/BankDocumentsExternalAccess.vue');
const AuditControl = () => import('@/views/audit/AuditControl');
const EmailLogsControl = () => import('@/views/logger/EmailLogsControl');
const ProfilesControl = () => import('@/views/access/ProfilesControl');
const FormProfile = () => import('@/views/access/FormProfile');
const InterbanksControl = () => import('@/views/interbank/InterbanksControl');
const CustomerAccessHome = () => import('@/views/customer-access/CustomerAccessHome');
const CustomerAccessOperations = () => import('@/views/customer-access/CustomerAccessOperations');
const CustomerAccessOperationReport = () =>
  import('@/views/customer-access/CustomerAccessOperationReport');
const CustomerAccessAccount = () => import('@/views/customer-access/CustomerAccessAccount');
const CustomerAccessOperationDetail = () =>
  import('@/views/customer-access/CustomerAccessOperationDetail.vue');
const OperationDetailPage = () => import('@/views/stablecoin/OperationDetailPage.vue');
const TosCallback = () => import('@/views/stablecoin/TosCallback');
const Home = () => import('@/views/Home.vue');
const PageNotFound = () => import('@/views/generic/PageNotFound');
const PageNotPermission = () => import('@/views/generic/PageNotPermission');
const FileView = () => import('@/views/generic/FileView');
const CustomerSelfie = () => import('@/views/customers/CustomerSelfie.vue');
const CorbanPublicSignup = () => import('@/views/correspondents/CorbanPublicSignup.vue');
const CustomerOperationApproval = () => import('@/views/operations/CustomerOperationApproval.vue');
const CustomerDashboard = () => import('@/views/dashboard/CustomerDashboard.vue');
const SetupWizard = () => import('@/views/onboarding/SetupWizard.vue');
const SupportRedirect = () => import('@/views/support/SupportRedirect.vue');

const routes = [
  {
    path: '/404',
    name: 'PageNotFound',
    component: PageNotFound,
    title: 'Página não encontrada',
    meta: { requireAuth: false }
  },
  {
    path: '/403',
    name: 'PageNotPermission',
    component: PageNotPermission,
    title: 'Página não encontrada',
    meta: { requireAuth: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    title: 'Login',
    meta: { requireAuth: false }
  },
  /* Vitrine do design system: exige login, perfil administrativo e ambiente
     fora de producao. As tres condicoes ficam no guard do router. */
  {
    path: '/ui',
    name: 'UIKit',
    component: UIKit,
    title: 'UI Kit — Design System',
    meta: { requireAuth: true }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    title: 'Home',
    meta: { requireAuth: true }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: InternationalDashboard,
    title: 'Dashboard',
    meta: { requireAuth: true }
  },
  {
    path: '/users',
    name: 'UsersControl',
    component: UsersControl,
    title: 'Controle de Usuários',
    meta: { requireAuth: true, accessCode: 'MENU_USUARIOS' }
  },
  {
    path: '/customers',
    name: 'CustomersControl',
    component: CustomersControl,
    title: 'Controle de Clientes',
    meta: { requireAuth: true, accessCode: 'MENU_CLIENTES' }
  },
  {
    path: '/customers/confirmation',
    name: 'FormCustomerFinally',
    component: FormCustomerFinally,
    title: 'Confirmação de cadastro',
    meta: { requireAuth: false }
  },
  {
    // Link fixo de ficha externa, para divulgar em site ou redes: com codigo e o
    // link do corban; sem codigo e o da empresa (cliente sem corban)
    path: '/cadastro/:code?',
    name: 'CorbanPublicSignup',
    component: CorbanPublicSignup,
    title: 'Cadastro de cliente',
    meta: { requireAuth: false }
  },
  {
    path: '/customers/external-acess/selfie/:token',
    name: 'CustomerSelfieExternalAccess',
    component: CustomerSelfie,
    title: 'Verificação de Identidade',
    meta: { requireAuth: false }
  },
  {
    // Link da operação para o cliente aprovar pela carteira dele e pagar (token de servidor)
    path: '/operacao/:token',
    name: ROUTE_NAMES.CUSTOMER_OPERATION_APPROVAL,
    component: CustomerOperationApproval,
    title: 'Confirmar operação',
    meta: { requireAuth: false }
  },
  {
    path: '/customers/selfie/admin/:customerId',
    name: 'CustomerSelfieAdmin',
    component: CustomerSelfie,
    title: 'Verificação de Identidade',
    meta: { requireAuth: true }
  },
  {
    path: '/customers/create',
    name: 'FormCreateCustomer',
    component: FormCustomer,
    title: 'Criação e Edição de Clientes',
    meta: { requireAuth: true, accessCode: 'MENU_CLIENTES' }
  },
  {
    path: '/customers/update/:id',
    name: 'FormEditCustomer',
    component: FormCustomer,
    title: 'Criação e Edição de Clientes',
    meta: { requireAuth: true, accessCode: 'MENU_CLIENTES' }
  },
  {
    path: '/customers/external-acess/:token',
    name: 'FormEditCustomerExternalAcess',
    component: FormCustomer,
    title: 'Criação e Edição de Clientes',
    meta: { requireAuth: false }
  },
  {
    path: '/customers-authorizations',
    name: 'CustomersAuthorizationControl',
    component: CustomersAuthorizationControl,
    title: 'Autorização de Clientes',
    meta: { requireAuth: true, accessCode: 'MENU_FLUXO_CADASTRAL' }
  },
  {
    path: '/customers-authorizations/:id',
    name: 'FormAuthorizationCustomer',
    component: FormAuthorizationCustomer,
    title: 'Autorização de Clientes',
    meta: { requireAuth: true, accessCode: 'MENU_FLUXO_CADASTRAL' }
  },
  {
    path: '/correspondents',
    name: 'CorrespondentsControl',
    component: CorrespondentsControl,
    title: 'Controle de Corban',
    meta: { requireAuth: true, accessCode: 'MENU_CORBAN_CADASTROS' }
  },
  {
    path: '/correspondents/create',
    name: 'FormCreateCorrespondent',
    component: FormCorrespondent,
    title: 'Criação e Edição de Corban',
    meta: { requireAuth: true, accessCode: 'MENU_CORBAN_CADASTROS' }
  },
  {
    path: '/correspondents/update/:id',
    name: 'FormEditCorrespondent',
    component: FormCorrespondent,
    title: 'Criação e Edição de Corban',
    meta: { requireAuth: true, accessCode: 'MENU_CORBAN_CADASTROS' }
  },
  {
    path: '/correspondents/external-acess/:token',
    name: 'FormEditCorrespondentExternalAcess',
    component: FormCorrespondent,
    title: 'Criação e Edição de Corban',
    meta: { requireAuth: false }
  },
  {
    path: '/operations',
    name: 'FormOperation',
    component: FormOperation,
    title: 'Cadastro de Operações',
    meta: { requireAuth: true, accessCode: 'MENU_OPERACOES' }
  },
  {
    /* Sem accessCode: notificação é de todo perfil — quem tem sino tem
       histórico. Restringir por menu deixaria Corban e Cliente com um link
       no painel que os leva a uma tela negada. */
    path: '/notifications',
    name: 'NotificationHistory',
    component: NotificationHistory,
    title: 'Histórico de Notificações',
    meta: { requireAuth: true }
  },
  {
    path: '/reports/operations/open',
    name: 'PreSaleReport',
    component: PreSaleReport,
    title: 'Relatório de Operações em Aberto',
    meta: { requireAuth: true, accessCode: 'MENU_RASCUNHO_OPERACOES' }
  },
  {
    path: '/operations/commissions',
    name: 'CommissionsControl',
    component: CommissionsControl,
    title: 'Controle de Comissões',
    meta: { requireAuth: true, accessCode: 'MENU_CORBAN_COMISSOES' }
  },
  {
    path: '/operations/:id/detail',
    name: 'OperationDetail',
    component: OperationDetailPage,
    title: 'Detalhe da Operação',
    meta: { requireAuth: true }
  },
  {
    path: '/operations/:id',
    name: 'FormEditOperation',
    component: FormOperation,
    title: 'Editar Operação',
    meta: { requireAuth: true, accessCode: 'MENU_OPERACOES' }
  },
  {
    path: '/reports/exchange',
    name: 'ExchangeOperationReport',
    component: ExchangeOperationReport,
    title: 'Relatório de Operações de Câmbio Turismo',
    meta: { requireAuth: true, accessCode: 'MENU_RELATORIOS_OPERACIONAIS_CAMBIO_TURISMO' }
  },
  {
    path: '/reports/remittance',
    name: 'RemittanceOperationReport',
    component: RemittanceOperationReport,
    title: 'Relatório de Operações de Remessa',
    meta: { requireAuth: true, accessCode: 'MENU_RELATORIOS_OPERACIONAIS_REMESSAS_INTERNACIONAIS' }
  },
  {
    path: '/reports/stablecoin/remittance',
    name: 'StablecoinRemittanceOperationReport',
    component: StablecoinRemittanceOperationReport,
    title: 'Relatório de Remessas Stablecoin',
    meta: { requireAuth: true }
  },
  {
    path: '/reports/exchange-closing',
    redirect: (to) => ({ path: '/exchange-closing', query: to.query })
  },
  {
    path: '/exchange-closing',
    name: 'ExchangeClosingReport',
    component: ExchangeClosing,
    title: 'Fechamento mensal',
    meta: { requireAuth: true, accessCode: 'MENU_RELATORIOS_OPERACIONAIS_CONTA_CORRENTE_BANCOS' }
  },
  {
    path: '/reports/remittance/management',
    name: 'RemittanceOperationManagementReport',
    component: RemittanceOperationManagementReport,
    title: 'Relatório Gerencial de Remessa',
    meta: { requireAuth: true, accessCode: 'MENU_RELATORIOS_OPERACIONAIS_LUCRO_REMESSAS_INTERNACIONAIS' }
  },
  {
    path: '/reports/import-data/management',
    name: 'DuimpDueOperationReport',
    component: DuimpDueOperationReport,
    title: 'Gestão de DUIMP/DU-E',
    meta: { requireAuth: true, accessCode: 'MENU_GESTAO_DUIMP_DUE' }
  },
  {
    path: '/reports/stablecoin/management',
    name: 'StablecoinRemittanceOperationManagementReport',
    component: StablecoinRemittanceOperationManagementReport,
    title: 'Relatório de Lucros Stablecoin',
    meta: { requireAuth: true }
  },
  {
    path: '/registrations/banks',
    name: 'ExchangeBankControl',
    component: ExchangeBankControl,
    title: 'Controle de Bancos',
    meta: { requireAuth: true, accessCode: 'MENU_CADASTROS_OPERACIONAIS_BANCOS' }
  },
  {
    path: '/registrations/banks/create',
    name: 'ExchangeFormCreateBank',
    component: ExchangeFormBank,
    title: 'Criação e Edição de Bancos',
    meta: { requireAuth: true, accessCode: 'MENU_CADASTROS_OPERACIONAIS_BANCOS' }
  },
  {
    path: '/registrations/banks/update/:id',
    name: 'ExchangeFormEditBank',
    component: ExchangeFormBank,
    title: 'Criação e Edição de Bancos',
    meta: { requireAuth: true, accessCode: 'MENU_CADASTROS_OPERACIONAIS_BANCOS' }
  },
  {
    path: '/registrations/operation-natures',
    name: 'OperationNaturesControl',
    component: OperationNaturesControl,
    title: 'Controle de Naturezas de Operação',
    meta: { requireAuth: true, accessCode: 'MENU_CADASTROS_OPERACIONAIS_NATUREZAS_OPERACAO' }
  },
  {
    path: '/registrations/currencies',
    name: 'CurrenciesControl',
    component: CurrenciesControl,
    title: 'Controle de Moedas',
    meta: { requireAuth: true, accessCode: 'MENU_CADASTROS_OPERACIONAIS_SPREADS_MOEDAS' }
  },
  {
    path: '/registrations/currency-holidays',
    name: 'CurrencyHolidaysControl',
    component: CurrencyHolidaysControl,
    title: 'Feriados por Moeda',
    meta: { requireAuth: true, accessCode: 'MENU_CADASTROS_OPERACIONAIS_FERIADOS' }
  },
  {
    path: '/registrations/payment-methods',
    name: 'PaymentMethodsControl',
    component: PaymentMethodsControl,
    title: 'Controle de Métodos de Pagamento',
    meta: { requireAuth: true, accessCode: 'MENU_CADASTROS_OPERACIONAIS_METODOS_PAGAMENTO' }
  },
  {
    path: '/registrations/rate-apis',
    name: 'RateApiRouteControl',
    component: RateApiRouteControl,
    title: 'Apis de Cotação',
    meta: { requireAuth: true, accessCode: 'MENU_CADASTROS_OPERACIONAIS_APIS_COTACAO' }
  },
  {
    path: '/registrations/templates',
    name: 'TemplatesControl',
    component: TemplatesControl,
    title: 'Templates',
    meta: { requireAuth: true, accessCode: 'MENU_CADASTROS_OPERACIONAIS_TEMPLATES' }
  },
  {
    path: '/registrations/templates/select-type',
    name: 'TemplateTypeSelector',
    component: TemplateTypeSelector,
    title: 'Selecionar tipo de template',
    meta: { requireAuth: true, accessCode: 'MENU_CADASTROS_OPERACIONAIS_TEMPLATES' }
  },
  {
    path: '/registrations/templates/create',
    name: 'FormTemplate',
    component: FormTemplate,
    title: 'Cadastro de templates',
    meta: { requireAuth: true, accessCode: 'MENU_CADASTROS_OPERACIONAIS_TEMPLATES' }
  },
  {
    path: '/registrations/templates/:id',
    name: 'FormEditTemplate',
    component: FormTemplate,
    title: 'Editar Template',
    meta: { requireAuth: true, accessCode: 'MENU_CADASTROS_OPERACIONAIS_TEMPLATES' }
  },
  {
    path: '/configuration',
    name: 'Configuration',
    component: Configuration,
    title: 'Configurações',
    meta: { requireAuth: true, accessCode: 'MENU_CONFIGURACOES' }
  },
  {
    path: '/file/view/*',
    name: 'FileView',
    component: FileView,
    title: 'Visualizando Arquivo',
    meta: { requireAuth: true }
  },
  {
    path: '/customer/documents/external-acess/:token',
    name: 'CustomerDocumentsExternalAccess',
    component: CustomerDocumentsExternalAccess,
    title: 'Documentos do Cliente',
    meta: { requireAuth: false }
  },
  {
    path: '/operation/documents/external-acess/:token',
    name: 'OperationDocumentsExternalAccess',
    component: OperationDocumentsExternalAccess,
    title: 'Documentos da Operação',
    meta: { requireAuth: false }
  },
  {
    path: '/duimp/external-access/:token',
    name: 'DuimpExternalAccess',
    component: DuimpExternalAccess,
    title: 'Upload DUIMP/DU-E',
    meta: { requireAuth: false }
  },
  {
    path: '/bank/operation/documents/external-access/:token',
    name: 'BankDocumentsExternalAccess',
    component: BankDocumentsExternalAccess,
    title: 'Documentos da Operação - Banco',
    meta: { requireAuth: false }
  },
  {
    path: '/audit/',
    name: 'AuditControl',
    component: AuditControl,
    title: 'Auditoria',
    meta: { requireAuth: true, accessCode: 'MENU_AUDITORIA' }
  },
  {
    path: '/api/stablecoin/terms-of-service/callback/:idempotencyKey',
    name: 'TosCallback',
    component: TosCallback,
    title: 'Processando Termos de Serviço',
    meta: { requireAuth: false }
  },
  {
    path: '/logs/email',
    name: 'EmailLogsControl',
    component: EmailLogsControl,
    title: 'Logs de Envio de E-mail',
    meta: { requireAuth: true, accessCode: 'MENU_EMAILS_ENVIADOS' }
  },
  // WhatsApp — feature desabilitada
  // {
  //   path: '/logs/whatsapp',
  //   name: 'WhatsAppLogsControl',
  //   component: WhatsAppLogsControl,
  //   title: 'Mensagens WhatsApp enviadas',
  //   meta: { requireAuth: true, accessCode: 'MENU_MENSAGENS_WHATSAPP' }
  // },
  // {
  //   path: '/whatsapp-inbox',
  //   name: 'WhatsAppChatInbox',
  //   component: WhatsAppChatInbox,
  //   title: 'WhatsApp Inbox',
  //   meta: { requireAuth: true, accessCode: 'MENU_WHATSAPP_INBOX' }
  // },
  {
    path: '/profiles',
    name: 'ProfilesControl',
    component: ProfilesControl,
    title: 'Perfil',
    meta: { requireAuth: true, accessCode: 'MENU_PERFIS' }
  },
  {
    path: '/interbank',
    name: 'InterbanksControl',
    component: InterbanksControl,
    title: 'Interbancário',
    meta: { requireAuth: true }
  },
  {
    path: '/profiles/create',
    name: 'FormCreateProfile',
    component: FormProfile,
    title: 'Criação e Edição de Perfis',
    meta: { requireAuth: true, accessCode: 'MENU_PERFIS' }
  },
  {
    path: '/profiles/update/:id',
    name: 'FormEditProfile',
    component: FormProfile,
    title: 'Criação e Edição de Perfis',
    meta: { requireAuth: true, accessCode: 'MENU_PERFIS' }
  },
  {
    path: '/customer-access',
    name: 'CustomerAccessHome',
    component: CustomerAccessHome,
    title: 'Visão do cliente',
    meta: { requireAuth: true }
  },
  {
    path: '/customer-access/operations',
    name: 'CustomerAccessOperations',
    component: CustomerAccessOperations,
    title: 'Visão do cliente',
    meta: { requireAuth: true }
  },
  {
    path: '/customer-access/operation-report',
    name: 'CustomerAccessOperationReport',
    component: CustomerAccessOperationReport,
    title: 'Visão do cliente',
    meta: { requireAuth: true }
  },
  {
    path: '/customer-access/account',
    name: 'CustomerAccessAccount',
    component: CustomerAccessAccount,
    title: 'Visão do cliente',
    meta: { requireAuth: true }
  },
  {
    path: '/customer-access/operation-report-detail/:id',
    name: 'CustomerAccessOperationDetail',
    component: CustomerAccessOperationDetail,
    title: 'Detalhe da Operação',
    meta: { requireAuth: true }
  },
  {
    path: '/customer-dashboard',
    name: 'CustomerDashboard',
    component: CustomerDashboard,
    title: 'Dashboard Cliente',
    meta: { requireAuth: true }
  },
  {
    path: '/first-steps',
    name: 'FirstSteps',
    component: SetupWizard,
    title: 'Primeiros Passos',
    /* `hideClara`: telas que ocupam a tela inteira e nao convivem com o painel
       lateral. A Clara empurra o conteudo pela direita, e aqui isso so abria
       uma faixa vazia ao lado do wizard. */
    meta: { requireAuth: true, hideClara: true }
  },
  /* Porta de entrada do suporte (DeepDesk): emite a assercao do usuario logado
     e redireciona ao portal. O caminho `/suporte` e convencao fixa entre os
     produtos — o DeepDesk manda o contato para ca. */
  {
    path: SUPPORT_ENTRY_PATH,
    name: ROUTE_NAMES.SUPPORT,
    component: SupportRedirect,
    title: 'Suporte',
    meta: { requireAuth: true, hideClara: true }
  }
];

export default routes;
